 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"app-admin":"app-admin","app-authoring-app-ds-app-main":"app-authoring-app-ds-app-main","app-authoring-app-main":"app-authoring-app-main","app-ds-app-main":"app-ds-app-main","app-main":"app-main","app-ds":"app-ds","app-extra-app-solo":"app-extra-app-solo","app-extra":"app-extra","app-solo":"app-solo","app-pwd":"app-pwd","chunk-vendors-ckeditor4":"chunk-vendors-ckeditor4","app-authoring":"app-authoring"}[chunkId]||chunkId) + "." + {"app-admin":"79e49dbc","app-authoring-app-ds-app-main":"e54652f9","app-authoring-app-main":"360372e8","app-ds-app-main":"da0a6057","app-main":"0c687dd0","app-ds":"3448c108","app-extra-app-solo":"ef584246","app-extra":"b0f4485e","app-solo":"b957c2ef","app-pwd":"72a692cc","chunk-2d0a35a4":"eea54c01","chunk-2d0a4ef2":"32ed3e7f","chunk-2d0a5151":"9fa105f9","chunk-2d0aa566":"05207399","chunk-2d0aaf09":"676dd9eb","chunk-2d0abe09":"b624ef4e","chunk-2d0ac40b":"d542d927","chunk-2d0aed27":"b1f13cc4","chunk-2d0af27c":"05fedaf7","chunk-2d0b2954":"a2c38927","chunk-2d0b39cb":"119cf414","chunk-2d0b6719":"005c22be","chunk-2d0b8ddc":"a29aff2f","chunk-2d0b9003":"3b3e5140","chunk-2d0b919c":"685f4527","chunk-2d0ba1c4":"4333753f","chunk-2d0ba462":"e46ebbcc","chunk-2d0ba757":"f46a2a88","chunk-2d0bae13":"754ec230","chunk-2d0bd263":"06ee1d8d","chunk-2d0c1bb7":"c95c2a31","chunk-2d0c4bd9":"b26e3bf6","chunk-2d0c4c35":"b2000732","chunk-2d0c7ce7":"8155f228","chunk-2d0c8069":"02d17e1c","chunk-2d0c89cb":"688a4829","chunk-2d0c8c20":"d7e72ed0","chunk-2d0c8c35":"7bb3315c","chunk-2d0cbc5a":"8de8096f","chunk-2d0cc0a6":"aca009c5","chunk-2d0ced80":"f0d0e439","chunk-2d0cfae2":"7daa9955","chunk-2d0d0197":"d5e7e25f","chunk-2d0d2ae8":"e8c1ba86","chunk-2d0d30f4":"5a922444","chunk-2d0d38d1":"efb097e3","chunk-2d0d3a96":"ae4dfda1","chunk-2d0d3c19":"f3f12f68","chunk-2d0d3fb6":"26b31d90","chunk-2d0d61dc":"3d89e9a8","chunk-2d0de343":"abc50430","chunk-2d0de940":"15c9b0f2","chunk-2d0e1459":"7831a556","chunk-2d0e59b3":"09d046a8","chunk-2d0e8ca0":"36fe7cbb","chunk-2d0e998d":"c1ac2d45","chunk-2d209638":"b662ee83","chunk-2d217318":"599ae474","chunk-2d217c5f":"ce4b41f6","chunk-2d21b4cb":"dae875c9","chunk-2d21e3c8":"debc26f0","chunk-2d21e599":"924c92e6","chunk-2d224d0e":"16e85978","chunk-2d225255":"b337a41d","chunk-2d2254d0":"84d24198","chunk-2d2259b9":"e831d10e","chunk-2d226ccb":"6bfb64f5","chunk-2d228ff3":"95312c51","chunk-2d2299c9":"eff2f5f2","chunk-2d22bcc3":"3cac3365","chunk-2d22cc61":"a6c76a1a","chunk-2d22d0a1":"4067e2eb","chunk-2d22dd6b":"335c9f64","chunk-2d230321":"57cdf2eb","chunk-2d230445":"755d5ebd","chunk-2d2308f4":"15053b75","chunk-2d2311ba":"52f0ab05","chunk-2d2380f1":"d47a7eba","chunk-2d238295":"75d793dc","chunk-74a954df":"2f296e3f","chunk-vendors-ckeditor4":"e6b360a0","app-authoring":"cba265a2","chunk-026d3a42":"d6548c6d","chunk-0317bb4c":"bc9b40b4","chunk-0535715e":"f67a7c25","chunk-0593d4db":"4a1476a0","chunk-092225ec":"f43a816e","chunk-09bc8540":"22fe4153","chunk-0f04d9ca":"5864d2c7","chunk-0f7c260c":"b5d1af20","chunk-0fd6fc1a":"27051c3b","chunk-10364d04":"579796e3","chunk-1094e360":"56520128","chunk-11657a7c":"3fb2971d","chunk-155e3598":"635ebc33","chunk-164566f2":"666f3b25","chunk-1c4d88d0":"2d0d2571","chunk-1c5a9c98":"729ef7de","chunk-245ee91f":"fd499c92","chunk-2d0a3196":"2f4ecd87","chunk-2d0a38f8":"54bff8ca","chunk-2d0a3d24":"58b4299e","chunk-2d0aa25f":"0f158244","chunk-2d0ac5ee":"ac23c03a","chunk-2d0afa6b":"d11b98a6","chunk-2d0b19f8":"1a039a6b","chunk-2d0b1e4f":"81983687","chunk-2d0b1f88":"7312af58","chunk-2d0b1fb9":"00a00ec2","chunk-2d0b2b45":"b02dc065","chunk-2d0b5f75":"21ed5c4d","chunk-2d0b8eec":"feee4a05","chunk-2d0bce75":"e6406ea2","chunk-2d0c0a93":"5282b0bc","chunk-2d0c14f8":"af5e4697","chunk-2d0ccbc7":"8cb40769","chunk-2d0cf2d5":"7e4a9662","chunk-2d0cf533":"f2076dcf","chunk-2d0cff02":"f8478c3d","chunk-2d0d017d":"8cfefd9d","chunk-2d0d3542":"d8911f36","chunk-2d0d61c3":"553d47c4","chunk-2d0d72d7":"bbf07b96","chunk-2d0d7897":"0b04b2f1","chunk-2d0d79fa":"f9163a08","chunk-2d0d7df5":"65576984","chunk-2d0da039":"7d57cef2","chunk-2d0da9a1":"8ebac0a1","chunk-2d0dd08c":"3b0c33be","chunk-2d0de8f2":"254141c5","chunk-2d0e1766":"fdeb7d7f","chunk-2d0e17c1":"187c61e0","chunk-2d0e28b9":"166af342","chunk-2d0e5ef6":"2143fbe3","chunk-2d0e6550":"46d6b6a4","chunk-2d0e942e":"7338fcbe","chunk-2d0efd87":"2fb96d53","chunk-2d208ffe":"fa787526","chunk-2d20ef86":"b9db4740","chunk-2d20fb34":"49125ac4","chunk-2d212c34":"133b0d03","chunk-2d2132d9":"ffa4d31e","chunk-2d213f09":"c8629ffc","chunk-2d217670":"5b6f0800","chunk-2d21d4d2":"5b3eece2","chunk-2d21eb2b":"c88225e6","chunk-2d21f859":"5aa978ff","chunk-2d22141a":"4edcd2b9","chunk-2d2225b3":"ec0dfe8b","chunk-2d22636c":"d1d5681d","chunk-2d22890e":"5b390f71","chunk-2d229787":"cff0d592","chunk-2d22c334":"4b01597c","chunk-2d22ce97":"1c80b63d","chunk-2d22d3a5":"b2aba446","chunk-2d22d728":"b573ec30","chunk-2d22e109":"f1ab4e81","chunk-31961831":"3ff6a1cd","chunk-36316270":"993d7645","chunk-396e93ac":"73579e67","chunk-3a3d387a":"10b56644","chunk-4600995c":"5887fc9a","chunk-49c04ea3":"a3b43d4e","chunk-4a888b04":"b1472ebb","chunk-4d190b39":"6e88c014","chunk-4f343cd6":"2b0da6ff","chunk-50da2fb3":"e6fbf6ac","chunk-519cab2c":"3fff5dce","chunk-56d4fb10":"ece05c60","chunk-58333402":"090ff909","chunk-5e542323":"e5a1a3ef","chunk-60e158ae":"cec26262","chunk-61adcf16":"d0df628e","chunk-62ff6535":"d57da859","chunk-699f247f":"682aa943","chunk-6d6fb740":"e5270629","chunk-744bbe6f":"830cda27","chunk-78747c1b":"9d22a113","chunk-79cb6d28":"078c3b88","chunk-84a711c2":"7c7c01b6","chunk-866b13cc":"da64a798","chunk-8cd3f8fe":"2456c535","chunk-92a84926":"2ce3d6b7","chunk-9365277c":"1cc70e17","chunk-940c2ac6":"1757393d","chunk-9600b49c":"6da6a6ab","chunk-9c49b824":"bde8916d","chunk-a7082daa":"e2153917","chunk-a7308c36":"25aa84cd","chunk-b2922d46":"18ef49ac","chunk-b53ccfb8":"c10474e9","chunk-c640d43e":"d2fb5d46","chunk-c9552520":"62190291","chunk-d03f5d28":"545fb194","chunk-d4f36ad8":"226902da","chunk-f6f7b446":"7c2e7504","chunk-f825eb1c":"358de943","chunk-fab08698":"12435bb8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"app-admin":1,"app-authoring-app-main":1,"app-ds-app-main":1,"app-main":1,"app-ds":1,"app-extra":1,"app-solo":1,"app-authoring":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"app-admin":"app-admin","app-authoring-app-ds-app-main":"app-authoring-app-ds-app-main","app-authoring-app-main":"app-authoring-app-main","app-ds-app-main":"app-ds-app-main","app-main":"app-main","app-ds":"app-ds","app-extra-app-solo":"app-extra-app-solo","app-extra":"app-extra","app-solo":"app-solo","app-pwd":"app-pwd","chunk-vendors-ckeditor4":"chunk-vendors-ckeditor4","app-authoring":"app-authoring"}[chunkId]||chunkId) + "." + {"app-admin":"19fbcdf3","app-authoring-app-ds-app-main":"31d6cfe0","app-authoring-app-main":"932c3bdd","app-ds-app-main":"7d59d135","app-main":"783bb13e","app-ds":"2b509cd0","app-extra-app-solo":"31d6cfe0","app-extra":"3e0e7f39","app-solo":"bb920e24","app-pwd":"31d6cfe0","chunk-2d0a35a4":"31d6cfe0","chunk-2d0a4ef2":"31d6cfe0","chunk-2d0a5151":"31d6cfe0","chunk-2d0aa566":"31d6cfe0","chunk-2d0aaf09":"31d6cfe0","chunk-2d0abe09":"31d6cfe0","chunk-2d0ac40b":"31d6cfe0","chunk-2d0aed27":"31d6cfe0","chunk-2d0af27c":"31d6cfe0","chunk-2d0b2954":"31d6cfe0","chunk-2d0b39cb":"31d6cfe0","chunk-2d0b6719":"31d6cfe0","chunk-2d0b8ddc":"31d6cfe0","chunk-2d0b9003":"31d6cfe0","chunk-2d0b919c":"31d6cfe0","chunk-2d0ba1c4":"31d6cfe0","chunk-2d0ba462":"31d6cfe0","chunk-2d0ba757":"31d6cfe0","chunk-2d0bae13":"31d6cfe0","chunk-2d0bd263":"31d6cfe0","chunk-2d0c1bb7":"31d6cfe0","chunk-2d0c4bd9":"31d6cfe0","chunk-2d0c4c35":"31d6cfe0","chunk-2d0c7ce7":"31d6cfe0","chunk-2d0c8069":"31d6cfe0","chunk-2d0c89cb":"31d6cfe0","chunk-2d0c8c20":"31d6cfe0","chunk-2d0c8c35":"31d6cfe0","chunk-2d0cbc5a":"31d6cfe0","chunk-2d0cc0a6":"31d6cfe0","chunk-2d0ced80":"31d6cfe0","chunk-2d0cfae2":"31d6cfe0","chunk-2d0d0197":"31d6cfe0","chunk-2d0d2ae8":"31d6cfe0","chunk-2d0d30f4":"31d6cfe0","chunk-2d0d38d1":"31d6cfe0","chunk-2d0d3a96":"31d6cfe0","chunk-2d0d3c19":"31d6cfe0","chunk-2d0d3fb6":"31d6cfe0","chunk-2d0d61dc":"31d6cfe0","chunk-2d0de343":"31d6cfe0","chunk-2d0de940":"31d6cfe0","chunk-2d0e1459":"31d6cfe0","chunk-2d0e59b3":"31d6cfe0","chunk-2d0e8ca0":"31d6cfe0","chunk-2d0e998d":"31d6cfe0","chunk-2d209638":"31d6cfe0","chunk-2d217318":"31d6cfe0","chunk-2d217c5f":"31d6cfe0","chunk-2d21b4cb":"31d6cfe0","chunk-2d21e3c8":"31d6cfe0","chunk-2d21e599":"31d6cfe0","chunk-2d224d0e":"31d6cfe0","chunk-2d225255":"31d6cfe0","chunk-2d2254d0":"31d6cfe0","chunk-2d2259b9":"31d6cfe0","chunk-2d226ccb":"31d6cfe0","chunk-2d228ff3":"31d6cfe0","chunk-2d2299c9":"31d6cfe0","chunk-2d22bcc3":"31d6cfe0","chunk-2d22cc61":"31d6cfe0","chunk-2d22d0a1":"31d6cfe0","chunk-2d22dd6b":"31d6cfe0","chunk-2d230321":"31d6cfe0","chunk-2d230445":"31d6cfe0","chunk-2d2308f4":"31d6cfe0","chunk-2d2311ba":"31d6cfe0","chunk-2d2380f1":"31d6cfe0","chunk-2d238295":"31d6cfe0","chunk-74a954df":"31d6cfe0","chunk-vendors-ckeditor4":"31d6cfe0","app-authoring":"eb340bc6","chunk-026d3a42":"31d6cfe0","chunk-0317bb4c":"31d6cfe0","chunk-0535715e":"31d6cfe0","chunk-0593d4db":"31d6cfe0","chunk-092225ec":"31d6cfe0","chunk-09bc8540":"31d6cfe0","chunk-0f04d9ca":"31d6cfe0","chunk-0f7c260c":"31d6cfe0","chunk-0fd6fc1a":"31d6cfe0","chunk-10364d04":"31d6cfe0","chunk-1094e360":"31d6cfe0","chunk-11657a7c":"31d6cfe0","chunk-155e3598":"31d6cfe0","chunk-164566f2":"31d6cfe0","chunk-1c4d88d0":"31d6cfe0","chunk-1c5a9c98":"31d6cfe0","chunk-245ee91f":"31d6cfe0","chunk-2d0a3196":"31d6cfe0","chunk-2d0a38f8":"31d6cfe0","chunk-2d0a3d24":"31d6cfe0","chunk-2d0aa25f":"31d6cfe0","chunk-2d0ac5ee":"31d6cfe0","chunk-2d0afa6b":"31d6cfe0","chunk-2d0b19f8":"31d6cfe0","chunk-2d0b1e4f":"31d6cfe0","chunk-2d0b1f88":"31d6cfe0","chunk-2d0b1fb9":"31d6cfe0","chunk-2d0b2b45":"31d6cfe0","chunk-2d0b5f75":"31d6cfe0","chunk-2d0b8eec":"31d6cfe0","chunk-2d0bce75":"31d6cfe0","chunk-2d0c0a93":"31d6cfe0","chunk-2d0c14f8":"31d6cfe0","chunk-2d0ccbc7":"31d6cfe0","chunk-2d0cf2d5":"31d6cfe0","chunk-2d0cf533":"31d6cfe0","chunk-2d0cff02":"31d6cfe0","chunk-2d0d017d":"31d6cfe0","chunk-2d0d3542":"31d6cfe0","chunk-2d0d61c3":"31d6cfe0","chunk-2d0d72d7":"31d6cfe0","chunk-2d0d7897":"31d6cfe0","chunk-2d0d79fa":"31d6cfe0","chunk-2d0d7df5":"31d6cfe0","chunk-2d0da039":"31d6cfe0","chunk-2d0da9a1":"31d6cfe0","chunk-2d0dd08c":"31d6cfe0","chunk-2d0de8f2":"31d6cfe0","chunk-2d0e1766":"31d6cfe0","chunk-2d0e17c1":"31d6cfe0","chunk-2d0e28b9":"31d6cfe0","chunk-2d0e5ef6":"31d6cfe0","chunk-2d0e6550":"31d6cfe0","chunk-2d0e942e":"31d6cfe0","chunk-2d0efd87":"31d6cfe0","chunk-2d208ffe":"31d6cfe0","chunk-2d20ef86":"31d6cfe0","chunk-2d20fb34":"31d6cfe0","chunk-2d212c34":"31d6cfe0","chunk-2d2132d9":"31d6cfe0","chunk-2d213f09":"31d6cfe0","chunk-2d217670":"31d6cfe0","chunk-2d21d4d2":"31d6cfe0","chunk-2d21eb2b":"31d6cfe0","chunk-2d21f859":"31d6cfe0","chunk-2d22141a":"31d6cfe0","chunk-2d2225b3":"31d6cfe0","chunk-2d22636c":"31d6cfe0","chunk-2d22890e":"31d6cfe0","chunk-2d229787":"31d6cfe0","chunk-2d22c334":"31d6cfe0","chunk-2d22ce97":"31d6cfe0","chunk-2d22d3a5":"31d6cfe0","chunk-2d22d728":"31d6cfe0","chunk-2d22e109":"31d6cfe0","chunk-31961831":"31d6cfe0","chunk-36316270":"31d6cfe0","chunk-396e93ac":"31d6cfe0","chunk-3a3d387a":"31d6cfe0","chunk-4600995c":"31d6cfe0","chunk-49c04ea3":"31d6cfe0","chunk-4a888b04":"31d6cfe0","chunk-4d190b39":"31d6cfe0","chunk-4f343cd6":"31d6cfe0","chunk-50da2fb3":"31d6cfe0","chunk-519cab2c":"31d6cfe0","chunk-56d4fb10":"31d6cfe0","chunk-58333402":"31d6cfe0","chunk-5e542323":"31d6cfe0","chunk-60e158ae":"31d6cfe0","chunk-61adcf16":"31d6cfe0","chunk-62ff6535":"31d6cfe0","chunk-699f247f":"31d6cfe0","chunk-6d6fb740":"31d6cfe0","chunk-744bbe6f":"31d6cfe0","chunk-78747c1b":"31d6cfe0","chunk-79cb6d28":"31d6cfe0","chunk-84a711c2":"31d6cfe0","chunk-866b13cc":"31d6cfe0","chunk-8cd3f8fe":"31d6cfe0","chunk-92a84926":"31d6cfe0","chunk-9365277c":"31d6cfe0","chunk-940c2ac6":"31d6cfe0","chunk-9600b49c":"31d6cfe0","chunk-9c49b824":"31d6cfe0","chunk-a7082daa":"31d6cfe0","chunk-a7308c36":"31d6cfe0","chunk-b2922d46":"31d6cfe0","chunk-b53ccfb8":"31d6cfe0","chunk-c640d43e":"31d6cfe0","chunk-c9552520":"31d6cfe0","chunk-d03f5d28":"31d6cfe0","chunk-d4f36ad8":"31d6cfe0","chunk-f6f7b446":"31d6cfe0","chunk-f825eb1c":"31d6cfe0","chunk-fab08698":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/advisor/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["app-authoring-app-ds-app-main","app-authoring-app-main","app-ds-app-main","app-main"]]);
 	return startupResult;
